import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '../store/index';
import { localStorage } from '@/config/localStorage';

Vue.use(VueRouter);

function isAuth(to: any, from: any, next: any) {
   if (store.getters['users/isAuth']) {
      // @ts-ignore
      if (to.name !== 'activities' && ['archive', 'orders', 'calendar'].includes(to.name) && (store.state.users.roles as number[]).includes(38)) {
         next({ name: 'activities' });
      } else {
         next();
      }
   } else {
      if (document.URL != '') {
         localStorage.setItem('prevRoute', document.URL);
      }
      next({ name: 'auth' });
   }
}

function notAuth(to: any, from: any, next: any) {
   if (!store.getters['users/isAuth']) {
      next();
   } else {
      next({ name: 'orders' });
   }
}

const routes: RouteConfig[] = [
   {
      path: '/',
      name: 'auth',
      component: () => import('@/views/Auth.vue'),
      beforeEnter: notAuth,
   },
   {
      path: '/',
      name: 'user',
      props: true,
      beforeEnter: isAuth,
      component: () => import('@/views/BasePage.vue'),
      children: [
         {
            path: 'calendar',
            name: 'calendar',
            //component: () => import('@/views/orders/Calendar.vue'),
            redirect: { name: 'orders' },
         },
         {
            path: 'reports',
            name: 'reports-list',
            component: () => import('@/views/BasePage.vue'),
            children: [
               {
                  path: 'activities',
                  name: 'reports:activities',
                  component: () => import('@/views/reports/Activities.vue'),
               },
               {
                  path: 'accommodations',
                  name: 'reports:accommodations',
                  component: () => import('@/views/reports/Accommodation.vue'),
               },
               {
                  path: 'transfers',
                  name: 'reports:transfers',
                  component: () => import('@/views/reports/Transfers.vue'),
               },
               {
                  path: 'tasks',
                  name: 'reports:tasks',
                  component: () => import('@/views/reports/Tasks.vue'),
               },
            ],
         },
         {
            path: 'orders',
            name: 'orders-list',
            component: () => import('@/views/BasePage.vue'),
            children: [
               {
                  path: ':id(\\d+)',
                  name: 'order.edit',
                  props: true,
                  component: () => import('@/views/orders/View.vue'),
               },
               {
                  path: 'check',
                  name: 'check',
                  props: true,
                  component: () => import('@/views/orders/Check.vue'),
               },
               {
                  path: '',
                  name: 'orders',
                  component: () => import('@/views/orders/List.vue'),
               },
            ],
         },
         {
            path: 'settings',
            name: 'settings',
            component: () => import('@/views/BasePage.vue'),
            children: [
               {
                  path: 'suppliers',
                  name: 'settings:suppliers-list',
                  component: () => import('@/views/BasePage.vue'),
                  children: [
                     {
                        path: ':id(\\d+)',
                        name: 'settings:supplier.edit',
                        props: true,
                        component: () => import('@/views/suppliers/View.vue'),
                     },
                     {
                        path: '',
                        name: 'settings:suppliers',
                        component: () => import('@/views/suppliers/List.vue'),
                     },
                  ],
               },
               {
                  path: 'activities',
                  name: 'activities-list',
                  component: () => import('@/views/BasePage.vue'),
                  children: [
                     {
                        path: ':id(\\d+)',
                        name: 'settings:activity.edit',
                        props: true,
                        component: () => import('@/views/activities/View.vue'),
                     },
                     {
                        path: '',
                        name: 'settings:activities',
                        component: () => import('@/views/activities/List.vue'),
                     },
                  ],
               },
            ],
         },
         {
            name: 'mobile',
            path: 'mobile',
            component: () => import('@/views/BasePage.vue'),
            children: [
               {
                  path: 'home',
                  name: 'mobile.home',
                  component: () => import('@/views/mobile/Index.vue'),
               },
               {
                  path: 'groups',
                  name: 'mobile.groups',
                  component: () => import('@/views/mobile/Groups.vue'),
               },
               {
                  path: 'activities',
                  name: 'mobile.activities',
                  component: () => import('@/views/mobile/Activities.vue'),
               },
               {
                  path: 'hotels',
                  name: 'mobile.hotels',
                  component: () => import('@/views/mobile/Hotels.vue'),
               },
            ],
         },
      ],
   },
   {
      name: 'reports',
      path: '',
      component: () => import('@/views/BasePage.vue'),
      children: [
         {
            path: '/activities-report/:id',
            name: 'activities.report',
            component: () => import('@/views/orders/reports/ActivityReport.vue'),
         },
         {
            path: '/accommodation-report/:id',
            name: 'accommodation.report',
            component: () => import('@/views/orders/reports/AccommodationReport.vue'),
         },
      ],
   },
];

export default new VueRouter({
   //mode: 'history',
   routes,
});
